class SectionFaqs extends HTMLElement {
  constructor() {
    super();

    this.triggers = [...this.querySelectorAll('[js-faqs="trigger"]')];
    this.contents = [...this.querySelectorAll('[js-faqs="content"]')];
    this.handleGroupClick = this.handleGroupClick.bind(this);
  }

  connectedCallback() {
    if (!this.triggers.length || !this.contents.length) {
      return;
    }

    this.triggers.forEach(group => {
      group.addEventListener('click', this.handleGroupClick);
    });
  }

  disconnectedCallback() {
    this.triggers.forEach(group => {
      group.removeEventListener('click', this.handleGroupClick);
    });
  }

  handleGroupClick(event) {
    const groupId = event.currentTarget?.dataset?.groupId;

    if (!groupId) {
      return;
    }

    this.triggers.forEach(group => {
      group.classList.toggle('is-active', group.dataset.groupId === groupId);
    });

    this.contents.forEach(content => {
      content.classList.toggle('is-active', content.dataset.groupId === groupId);
    });
  }
}

customElements.define('section-faqs', SectionFaqs);
